import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  ComponentFactoryResolver,
  Input,
  Output,
  EventEmitter,
  ComponentRef,
  StaticProvider,
  Injector,
} from '@angular/core';

@Component({
  selector: 'app-dcl',
  templateUrl: './dcl.component.html',
  styleUrls: ['./dcl.component.scss'],
})
export class DclComponent implements OnInit {
  @Input() component;
  @Input() data;

  @Input() providers: StaticProvider[];

  @Output() ref: EventEmitter<any> = new EventEmitter<any>();

  public componentInstance: ComponentRef<any>;

  @ViewChild('content', { read: ViewContainerRef, static: true })
  content: ViewContainerRef;

  constructor(
    private fr: ComponentFactoryResolver,
    private injector: Injector
  ) {}

  ngOnInit() {
    const factory = this.fr.resolveComponentFactory(this.component);
    let injector = null;

    if (this.providers) {
      injector = Injector.create({
        parent: this.injector,
        providers: this.providers,
      });
    }
    this.componentInstance = this.content.createComponent(factory, 0, injector);

    for (const item in this.data) {
      if (this.data[item]) {
        this.componentInstance.instance[item] = this.data[item];
      }
    }

    this.ref.emit(this.componentInstance.instance);
  }
}
